import { KnBrDraftOrdersService } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.service';
import { KnBrAddRequestEntry } from './../../models/kn-br-order.model';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, Product, TranslatePipe } from '@spartacus/core';
import { CurrentProductService, LaunchDialogService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KnBrCommonService } from '../../services/kn-br-common.service';
import { KnBrProductSelectService } from '../../services/kn-br-product-select.service';
import { KnBrCartContextService } from '../../store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrQuoteContextService } from '../../store/kn-br-quote-context/kn-br-quote-context.service';
import { KnBrQuotesService } from '../../store/kn-br-quotes/kn-br-quotes.service';
import { KnBrDraftOrder } from './../../models/kn-br-draft-order.model';
import { KnBrSelectCartComponent } from './kn-br-select-cart/kn-br-select-cart.component';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { UserAccountService } from '@spartacus/user/account/core';
import { MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { KnBrNumbersOnlyDirective } from '../../shared/directive/kn-br-numbers-only.directive';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-add-to-cart',
    templateUrl: './kn-br-add-to-cart.component.html',
    styleUrls: ['./kn-br-add-to-cart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [ReactiveFormsModule, KnBrNumbersOnlyDirective, NgbTooltip, AsyncPipe, TranslatePipe]
})
export class KnBrAddToCartComponent implements OnInit, OnDestroy {
  minQuantity: any;
  @Input() type = 'PDP';
  @Input() isOrderable = true;
  @Input() productCode: string;
  /**
   * As long as we do not support #5026, we require product input, as we need
   *  a reference to the product model to fetch the stock data.
   */
  @Input() product: Product;
  maxQuantity: number;
  modalRef: any;
  hasStock = false;
  quantity = 1;
  increment = false;
  cartEntry$: Observable<OrderEntry>;
  cartEntries$: Observable<OrderEntry[]>;
  subscription = new Subscription();
  addToCartForm = new FormGroup({
    quantity: new FormControl(1),
  });
  cartContext: string;
  quoteContext: string;
  selectedProductCodes: string[];
  isSaveDisabled$: Observable<boolean> = this.activeCartService.getLoading();
  editable = false;
  quoteEditable = false;
  @Input() productList: KnBrAddRequestEntry[];
  customerContext: string;
  addProductAction: any;

  constructor(
    protected modalService: NgbModal,
    protected currentProductService: CurrentProductService,
    protected cd: ChangeDetectorRef,
    protected activeCartService: ActiveCartService,
    protected knBrCartContextService: KnBrCartContextService,
    protected knBrProductService: KnBrProductSelectService,
    protected messageService: GlobalMessageService,
    protected knBrQuoteContextService: KnBrQuoteContextService,
    protected commonService: KnBrCommonService,
    protected knBrQuotesService: KnBrQuotesService,
    protected knBrDraftOrderService: KnBrDraftOrdersService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected currentUserService: UserAccountService,
    private multiCartFacade: MultiCartFacade,
  ) {}
  ngOnInit() {
    this.subscription.add(
      this.currentUserService
        .get()
        .subscribe((user: any) => (this.addProductAction = user ? user.allowProductOrderable : true))
    );
    this.subscription.add(
      this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
        this.customerContext = response ? response : null;
      })
    );
    this.subscription.add(
      this.knBrCartContextService.get$.subscribe((data) => {
        this.cartContext = data;
        this.editable = false;
        this.quoteEditable = false;
        if (data) {
          this.isEditable();
        } else {
          this.editable = true;
          this.quoteEditable = true;
        }
        this.cd.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrQuoteContextService.get$.subscribe((data) => {
        this.quoteContext = data;
        this.quoteEditable = false;
        if (data) {
          this.isEditable();
        } else {
          this.quoteEditable = true;
        }
        if (this.cartContext) {
          if (this.product) {
            this.productCode = this.product.code;
            this.cartEntry$ = this.multiCartFacade.getLastEntry(this.cartContext, this.productCode);
            this.cartEntries$ = this.multiCartFacade.getEntries(this.cartContext);
            this.setStockInfo(this.product);
            this.cd.markForCheck();
          } else if (this.productCode) {
            this.cartEntry$ = this.multiCartFacade.getLastEntry(this.cartContext, this.productCode);
            this.cartEntries$ = this.multiCartFacade.getEntries(this.cartContext);
            // force hasStock and quantity for the time being, as we do not have more info:
            this.quantity = 1;
            this.hasStock = true;
            this.cd.markForCheck();
          } else {
            this.subscription.add(
              this.currentProductService
                .getProduct()
                .pipe(filter(Boolean))
                .subscribe((product: Product) => {
                  this.productCode = product.code;
                  this.setStockInfo(product);
                  this.cartEntry$ = this.multiCartFacade.getLastEntry(this.cartContext, this.productCode);
                  this.cartEntries$ = this.multiCartFacade.getEntries(this.cartContext);
                  this.cd.markForCheck();
                })
            );
            this.subscription.add(
              this.addToCartForm.get('quantity').valueChanges.subscribe((quantity) => {
                this.commonService.setPDPQuantity(quantity);
              })
            );
          }
        }
        this.cd.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrProductService.loadSelectedProducts$().subscribe((selectedProductCodes) => {
        this.selectedProductCodes = selectedProductCodes;
        this.cd.markForCheck();
      })
    );


  }

  setStockInfo(product: any): void {
    this.quantity = product.minOrderQuantity ? product.minOrderQuantity : 1;
    this.minQuantity = this.quantity;
    this.addToCartForm.controls.quantity.setValidators([Validators.min(this.minQuantity)]);
    this.hasStock = product.stock && product.stock.stockLevelStatus !== 'outOfStock';
    if (this.hasStock && product.stock.stockLevel) {
      this.maxQuantity = product.stock.stockLevel;
    }
    this.addToCartForm.controls.quantity.updateValueAndValidity();
    this.addToCartForm.get('quantity').patchValue(this.quantity);
  }

  updateCount(value: number): void {
    this.quantity = value;
  }

  onQuantityBlur() {
    const qty = this.addToCartForm.get('quantity').value;
    const qtyBasedOnMoq = this.commonService.getQuantityBasedOnMoq(qty, this.minQuantity);
    this.addToCartForm.get('quantity').patchValue(qtyBasedOnMoq);
  }

  addToCart() {
    this.knBrProductService.setSelectedProducts([]);
    const quantity = this.addToCartForm.get('quantity').value;
    if (!this.productCode || quantity <= 0) {
      return;
    }
    if (!this.cartContext) {
      this.openModal();
    } else {
      this.multiCartFacade.addEntry(null, this.cartContext, this.productCode, quantity);
    }
  }
  addMultipleProducts() {
    if (this.selectedProductCodes && this.selectedProductCodes.length) {
      this.productCode = this.selectedProductCodes.toString();
      this.addToCart();
    } else {
      this.messageService.add({ raw: 'Please select product(s).' }, GlobalMessageType.MSG_TYPE_WARNING);
    }
  }
  openModal() {
    let modalInstance: any;
    this.quantity = this.addToCartForm.get('quantity').value;
    this.modalRef = this.modalService.open(KnBrSelectCartComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.productCode = this.productCode;
    modalInstance.quantity = this.quantity;
    modalInstance.productList = this.productList;
  }

  isEditable() {
    this.editable = true;
    this.subscription.add(
      this.multiCartFacade.getCart(this.cartContext).subscribe((draftOrder: KnBrDraftOrder) => {
        this.editable = true;
        if (draftOrder && this.cartContext) {
          this.editable = draftOrder.editable;
        }
        this.cd.markForCheck();
      })
    );
    this.isQuoteEditable();
  }

  isQuoteEditable() {
    this.quoteEditable = true;
    this.subscription.add(
      this.knBrQuotesService.get$.subscribe((quote) => {
        if (quote && Object.keys(quote).length && quote?.code && this.quoteContext) {
          this.quoteEditable = quote.editable;
        }
        this.cd.markForCheck();
      })
    );
  }

  addProductsToCart() {
    if (!this.cartContext) {
      this.openModal();
    } else if (this.productList && this.productList.length > 0) {
      const req = {
        cartId: this.cartContext,
        request: this.productList,
      };
      this.knBrDraftOrderService.quickEntry(req);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
